import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuildingModern = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "building-modern" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.25,9.75h8.5a1,1,0,0,1,1,1v12.5a0,0,0,0,1,0,0H2.25a0,0,0,0,1,0,0V10.75A1,1,0,0,1,3.25,9.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,23.25h6v-21a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5v4.5h1.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 23.25,
			x2: .75,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 21.75,
			y1: 23.25,
			x2: 23.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 3.75,
			x2: 14.25,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 12.75,
			x2: 4.5,
			y2: 12.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,23.25h-3v-3a1.5,1.5,0,0,1,3,0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.75,23.25h-3v-4.5a1.5,1.5,0,0,1,3,0Z"
		})
	]
});
export default SvgBuildingModern;
